import React, { useEffect, useState, useContext } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, useParams } from "react-router-dom"; // Import useHistory
import Products from "../Components/product.component";
import { FirebaseContext } from "../admin/context/FirebaseContext";
import { collection, getDocs } from "firebase/firestore";
import Skeleton from "@mui/material/Skeleton";
import "@splidejs/react-splide/css/core";
import "../styles/content.style.scss";
import "../styles/ventes.style.scss";

function Ventes() {
  const location = useLocation();
  const params = useParams();
  const { db } = useContext(FirebaseContext);
  const categorieRef = collection(db, "categoriesProducts");
  const productsRef = collection(db, "products");

  const searchParams = new URLSearchParams(location.search);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [categorieWithLabel, setCategorieWithLabel] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchField, setSearchField] = useState(searchParams.get("q") || "");
  const [search, setSearch] = useState(searchParams.get("q") || "");
  const [categorie, setCategorie] = useState(searchParams.get("cat") || "all");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  function handleChange(e) {
    setSearchField(e.target.value);
    if (e.target.value === "") {
      setSearch("");
    }
  }
  function handleSubmit(e) {
    e.preventDefault();
    setSearch(searchField);
  }

  useEffect(() => {
    // Update URL parameters when search or category changes
    const updateURLParams = () => {
      const params = new URLSearchParams();
      if (search) params.set("q", search);
      if (categorie && categorie !== "all") params.set("cat", categorie);

      // Replace the current URL with the updated parameters
      window.history.replaceState(
        {},
        "",
        `${location.pathname}?${params.toString()}`
      );
    };

    updateURLParams();
  }, [search, categorie]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const snapshot = await getDocs(categorieRef);
        const categoryData = [];
        const categorieDataLabel = {};
        snapshot.docs.forEach((doc) => {
          categoryData.push({ id: doc.id, ...doc.data() });
          categorieDataLabel[doc.id] = doc.data();
        });
        setCategories(categoryData);
        setCategorieWithLabel(categorieDataLabel);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const snapshot = await getDocs(productsRef).then((docs) => {
          setLoading(false);
          return docs;
        });
        const productData = [];

        snapshot.forEach((doc) => {
          productData.push({ id: doc.id, ...doc.data() });
        });
        setProducts(productData);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title> Ventes | GI</title>
        <meta
          name="keywords"
          content="Ventes Camera,Camera, Video surveillance,Généralité informatique,Caméras de sécurité pour les entreprises, Systèmes de caméras de sécurité, Installation de caméras de sécurité, Maintenance de caméras de sécurité, Réparation de caméras de sécurité,"
        />
        <link
          rel="canonical"
          href="https://www.generalite-informatique.vercel.app/ventes"
        />
        <meta
          property="og:title"
          content="Ventes des produits : Cameras , Fourniture Bureau et autre"
        />
      </Helmet>
      <div className="App top-ctn">
        <>
          <div className="ctn-field">
            <form action="" className="search-field" onSubmit={handleSubmit}>
              <input
                type="search"
                name="search"
                id="search"
                value={searchField}
                onChange={handleChange}
                placeholder="Rechercher ...."
              />
              <button className="btn-btn btn-search" type="submit">
                Chercher
              </button>
            </form>
            <div className="ctn-cat">
              <h1 className="hightlight-title">Categorie : </h1>
              <ul className="filter-link">
                <span className="left-arrow">&larr;</span>
                <span className="right-arrow">&rarr;</span>
                {!loading ? (
                  <>
                    <li>
                      <a
                        href="#all"
                        className={categorie === "all" ? "active" : ""}
                        onClick={(e) => {
                          e.preventDefault();
                          setCategorie("all");
                        }}
                      >
                        Tout
                      </a>
                    </li>
                    {categories.map((c) => (
                      <li key={c.id}>
                        <a
                          href={c.name}
                          className={categorie === c.name ? "active" : ""}
                          onClick={(e) => {
                            e.preventDefault();
                            setCategorie(c.name);
                          }}
                        >
                          {c.name}
                        </a>
                      </li>
                    ))}
                  </>
                ) : (
                  <>
                    <li>
                      <Skeleton
                        animation="wave"
                        width={150}
                        height={55}
                        sx={{
                          borderRadius: "20px",
                        }}
                      />
                    </li>
                    <li>
                      <Skeleton
                        animation="wave"
                        width={80}
                        height={55}
                        sx={{
                          borderRadius: "20px",
                        }}
                      />
                    </li>
                    <li>
                      <Skeleton
                        animation="wave"
                        width={95}
                        height={55}
                        sx={{
                          borderRadius: "20px",
                        }}
                      />
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
          <div className="ctn-content">
            <div className="list-prod">
              <Products
                isLoading={loading}
                products={products}
                filter={search}
                categorie={categorie}
                listCategorie={categorieWithLabel}
              />
            </div>
          </div>
        </>
      </div>
    </>
  );
}

export default Ventes;
